if (!customElements.get('featured-articles-slider')) {
  class FeaturedArticlesSlider extends HTMLElement {
    selectors = {
      slider: '.swiper',
      arrows: {
        prev: '[article-slider-arrow-prev]',
        next: '[article-slider-arrow-next]',
      },
    };
    settings = {};
    slider = undefined;

    /**
     * Constructor.
     */
    constructor() {
      super();
    }

    /**
     * Connected callback.
     */
    connectedCallback() {
      this.init();
    }

    /**
     * Init.
     */
    init() {
      this.settings = {
        slidesPerView: 1.5,
        initialSlide: 1,
        centeredSlides: true,
        navigation: {
          prevEl: this.querySelector(this.selectors.arrows.prev),
          nextEl: this.querySelector(this.selectors.arrows.next),
        },
        spaceBetween: 20,
        breakpoints: {
          990: {
            slidesPerView: 3,
            centeredSlides: false,
            initialSlide: 0,
          },
        },
      };

      this.slider = new Swiper(
        this.querySelector(this.selectors.slider),
        this.settings
      );
    }
  }
  customElements.define(
    'featured-articles-slider',
    FeaturedArticlesSlider
  );
}
